import { useEffect } from 'react'

import { IconRefresh } from '@tabler/icons-react'

import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogDismiss,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
} from '@/components/common/responsive-dialog'
import { Button } from '@/components/sui/button'
import { useComponentTranslation } from '@/hooks/use-component-translation'
import { logger } from '@/lib/logger'

import locales from './locales'
import {
  trackUpdateDialogAccepted,
  trackUpdateDialogDismissed,
  trackUpdateDialogShown,
} from './update-dialog.tracking'

interface UpdateDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function UpdateDialog({ open, onOpenChange }: UpdateDialogProps) {
  const { t } = useComponentTranslation(locales)

  useEffect(() => {
    if (open) {
      logger.info('Version update dialog shown', undefined, 'version')
      trackUpdateDialogShown()
    }
  }, [open])

  function handleUpdate() {
    trackUpdateDialogAccepted()
    window.location.reload()
  }

  // Every way out is a postponement, the X and Escape included.
  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) trackUpdateDialogDismissed()
    onOpenChange(nextOpen)
  }

  return (
    <ResponsiveDialog open={open} onOpenChange={handleOpenChange}>
      <ResponsiveDialogContent>
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle icon={<IconRefresh />}>
            {t('title')}
          </ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            {t('description')}
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>
        <ResponsiveDialogFooter>
          <ResponsiveDialogDismiss intent="cancel">
            {t('later')}
          </ResponsiveDialogDismiss>
          <Button onClick={handleUpdate}>
            <IconRefresh className="h-4 w-4" />
            {t('updateNow')}
          </Button>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  )
}
